import type { CourtesyLoan } from '@/hooks/useCourtesyVehicles';
import type { BookingStatus } from '@/types';

/** The customer's vehicle is at the workshop: a reserved car is due to go out. */
const ARRIVED_STATUSES: ReadonlySet<BookingStatus> = new Set<BookingStatus>([
  'vehicle_arrived',
  'in_progress',
  'paused',
  'waiting_parts',
]);

/** The work is done: the customer comes back for the vehicle and returns the loan. */
const PICKUP_STATUSES: ReadonlySet<BookingStatus> = new Set<BookingStatus>([
  'work_completed',
  'ready_to_invoice',
  'on_consolidated_invoice',
  'invoiced',
  'completed',
]);

/**
 * Where the notice shows (#4103):
 * - `arrival`: top of the work order. A reserved car once the vehicle has
 *   arrived (hand it over), a car still out once the work is done (take it back).
 * - `pickup`: the Payments / handover card. Every open loan, whatever the
 *   status, so the return is not missed when the customer collects the vehicle.
 */
export type CourtesyLoanNoticePlacement = 'arrival' | 'pickup';

export function courtesyNoticeLoans(
  loans: readonly CourtesyLoan[],
  status: BookingStatus,
  placement: CourtesyLoanNoticePlacement,
): CourtesyLoan[] {
  return loans.filter((loan) => {
    if (placement === 'pickup') return loan.status === 'reserved' || loan.status === 'out';
    if (loan.status === 'reserved') return ARRIVED_STATUSES.has(status);
    if (loan.status === 'out') return PICKUP_STATUSES.has(status);
    return false;
  });
}
